import { name } from "./";

const selectSchoolDetails = (state) => state[name].schoolDetails;
const selectCalendar = (state) => state[name].calendar;

export { selectSchoolDetails, selectCalendar };
